var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"contianer-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('p',{staticClass:"back-text",on:{"click":function($event){return _vm.backBtn()}}},[_vm._m(0),_vm._v("Back")])]),_c('div',{staticClass:"col-md-4"})])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"fa fa-chevron-left"})])
}]

export { render, staticRenderFns }